(ns machtfit.stepchall.api
  (:require [machtfit.api :as api]
            [machtfit.app.routes :as routes]
            [machtfit.startpage.events :as events]
            [re-frame.core :as rf]))

(defn request [db {:keys [function params page-on-success] :as options}]
  (api/request db
               (merge {:data `[(~function ~params :stepchall-result)]
                       :on-success #(rf/dispatch [::stepchall-api-received
                                                  {:received %
                                                   :page-on-success page-on-success}])
                       :on-error #(rf/dispatch [::stepchall-api-error])}
                      options)))

(rf/reg-event-fx ::stepchall-api-received
  (fn [{:keys [db]} [_ {:keys [received page-on-success]}]]
    (let [result (-> received :result :stepchall-result)]
      {:db (if (:success result)
             (-> db
                 (assoc :stepchall (:result result))
                 (update-in [:ui :page] dissoc :add-activity-request-in-progress?)
                 (update-in [:ui :page] dissoc :add-activity-request-in-progress-from-modal?)
                 (update-in [:ui :page] dissoc :error)
                 (update-in [:ui :page] dissoc :activity)
                 (update-in [:ui :stepchall] dissoc :activity-value)
                 (update-in [:ui :page] #(merge % page-on-success)))
                                ;; TODO: hier haben wir jetzt einen zweiten Mechanismus geschaffen, zu einer Page zu navigieren
                                ;; der erste ist in routes/on-click-link
             (-> db
                 (assoc-in [:ui :page :error] (-> result
                                                  :error
                                                  (update :name keyword)))
                 (update-in [:ui :page] dissoc :add-activity-request-in-progress?)
                 (update-in [:ui :page] dissoc :add-activity-request-in-progress-from-modal?)))
       ::events/change-url (when (some? page-on-success) (routes/page-url page-on-success))})))

(rf/reg-event-db ::stepchall-api-error
  (fn [db _]
    (-> db
        (update-in [:ui :page] dissoc :add-activity-request-in-progress?)
        (update-in [:ui :page] dissoc :add-activity-request-in-progress-from-modal?))))
